// extracted by mini-css-extract-plugin
var _1 = "MagneticWall-module__animateUploadProgressBarWidth--tmG0Z";
var _2 = "MagneticWall-module__animatedBackground--UyZeg";
var _3 = "MagneticWall-module__item--_8PB1";
var _4 = "MagneticWall-module__layoutContainer--ltet0";
var _5 = "290px";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "item", _4 as "layoutContainer", _5 as "magneticWallMaxWidth" }
